import { Amount } from 'Shared/forms/Amount';
import { Text } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap, LabelOnRightWrap } from 'Shared/forms/Wrap';
import { sizes } from 'Shared/backend/Theme';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


/* The home-page banner logo's left/right padding ramps between these two container widths by
   default - 20px on a phone out to 300px on the desktop, the pair the two venues that carried this
   in code (The Drummer / Showcase 3) ran. */
const fluidPaddingDefaults = {
	pageMin:  sizes().endFontShrink,
	minValue: 20,
	pageMax:  sizes().minDesktopWidth,
	maxValue: 300,
};


export function BannerLogo()
{
	return (
		<StyleFieldsRow>
			<BannerLogoFields />
		</StyleFieldsRow>
	);
}


/* The banner logo's side padding and height on their own, for a caller that names the location
   itself - see ruleProperties(). Padding is a fixed px or a fluid ramp; height is any css length
   ('60vh'). An empty field contributes nothing. */
export function BannerLogoFields()
{
	return (<>
		<LabelOnLeftWrap label='Side padding' narrow={true}>
			<Amount field='padding' options={{px:'px', fluid:'fluid'}} fluidDefaults={fluidPaddingDefaults} />
		</LabelOnLeftWrap>
		<LabelOnRightWrap label='Height' narrow={true}>
			<Text field='height' placeholder='e.g. 60vh' />
		</LabelOnRightWrap>
	</>);
}
